import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';
import { BlocksIconDocumentParts } from 'blocks-nextjs/blocks-web-components/components/icon/icons/document-parts';

export const CatIconDocumentParts = createComponent({
  react: React,
  tagName: 'cat-icon-document-parts',
  elementClass: BlocksIconDocumentParts
});
